import { Suspense, useEffect } from "react"
import { Route, Routes } from "react-router-dom"
import { toast, ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { getMessaging, getToken, onMessage } from "firebase/messaging"
import { Loader, Protected } from "./components"
import { firebaseApp } from "./firebaseApp"
import { EventDetailsPage, HomePage, LoginPage, ProfilePage, QuestionnairePage, ScanPage, SuccessPage } from "./pages"
import Firestore from "./services/FirestoreService"

const App = () => {
	const checkAndSendMessages = async () => {
		if (window.Notification) {
			const messages = getMessaging(firebaseApp)
			getToken(messages, { vapidKey: process.env.REACT_APP_VAPID })

			Notification.requestPermission().then((permission) => {
				if (permission === "granted") {
					console.log("Notification permission granted.")
				}
			})

			onMessage(messages, (payload) => {
				console.log("Message received. ", payload)
				// const { title, ...options } = payload.notification

				toast.info(`${payload.notification?.title ?? ""}`, {
					position: "top-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
				})
			})
		}
	}

	useEffect(() => {
		Firestore.init().catch(() => console.error("Could not init offline support"))
	}, [])

	useEffect(() => {
		checkAndSendMessages()
	}, [])

	return (
		<Suspense fallback={<Loader />}>
			<div className="md:mx-auto md:w-1/2 xl:w-1/3">
				<ToastContainer
					position="top-right"
					autoClose={5000}
					hideProgressBar={false}
					newestOnTop={false}
					closeOnClick
					rtl={false}
					pauseOnFocusLoss
					draggable
					pauseOnHover
				/>
				<Routes>
					<Route path="/" element={<Protected />}>
						<Route index element={<HomePage />} />
						<Route path="profile" element={<ProfilePage />} />
						<Route path="questionnaire" element={<QuestionnairePage />} />
						<Route path="scan" element={<ScanPage />} />
						<Route path="success" element={<SuccessPage />} />
						<Route path="event/:id" element={<EventDetailsPage />} />
					</Route>
					<Route path="/login" element={<LoginPage />} />
				</Routes>
			</div>
		</Suspense>
	)
}

export default App
